import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/auth";

/**
 * Wraps a set of routes that require an authenticated AppUser session.
 * Renders a brief loading state until the initial /api/auth/me probe
 * resolves, then either lets the child route render or bounces to /login
 * preserving the original target via the location state so the login
 * page can redirect back after success.
 */
export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
